.modal {
    position: fixed;
    z-index: 9000;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.body {
    z-index: 1; /* Above overlay. */
}

@keyframes modal-overlay-animate-in {
    0% {
        background-color: transparent;
    }
    100% {
        background-color: var(--modal-overlay);
    }
}

.underlay {
    background-color: var(--modal-overlay);
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 0;
    animation: modal-overlay-animate-in 200ms ease-in-out;
}

.ai-agent-sidebar-open {
    width: calc(100% - 400px);
}
